import {SportstypeSpec} from "../types"

import main from "../../icons/cyclocross/main"
import Start from "../../icons/cyclocross/start"
import Finish from "../../icons/cyclocross/finish"
import EndOfLap from "../../icons/cyclocross/end-of-lap"
import BikeChange from "../../icons/cyclocross/bike-change"
import Breakaway from "../../icons/cyclocross/breakaway"
import MechanicalIssue from "../../icons/cyclocross/mechanical-issue"
import GiveUp from "../../icons/cyclocross/give-up"
import Crash from "../../icons/cyclocross/crash"

const cyclocross: SportstypeSpec = {
    id: 'cyclocross',
    scoreboardType: undefined,
    svg: main,
    releaseStage: 'released',
    defaultTiming: {
      _type: "Tik::Model::Options::CountingGameOptions",
      timing_type: "u",
      entity_type: "laps",
    },
    phases: ['pregame', 'pre-race', 'live-race', 'post-race', 'postgame'],
    events: [
      {
        id: 'start',
        important: false,
        svg: Start
      },
      {
        id: 'end',
        important: false,
        svg: Finish,
        // team: 'any',
        players: [
          {
            id: 'rider',
            from: 'any'
          }
        ]
      },
      {
        id: 'end-of-lap',
        important: true,
        svg: EndOfLap,
        // team: 'any',
        players: [
          {
            id: 'rider',
            from: 'any',
            max: 100
          }
        ]
      },
      {
        id: 'bike-change',
        important: true,
        svg: BikeChange,
        // team: 'any',
        players: [
          {
            id: 'rider',
            from: 'any',
            max: 100
          }
        ]
      },
      {
        id: 'breakaway',
        important: true,
        svg: Breakaway,
        // team: 'any',
        players: [
          {
            id: 'rider',
            from: 'any',
            max: 100
          }
        ]
      },
      {
        id: 'crash',
        important: true,
        svg: Crash,
        // team: 'any',
        players: [
          {
            id: 'rider',
            from: 'any',
            max: 100
          }
        ]
      },
      {
        id: 'mechanical-issue',
        important: true,
        svg: MechanicalIssue,
        // team: 'any',
        players: [
            {
                id: 'rider',
                from: 'any'
            }
        ]
      },
      {
        id: 'give-up',
        important: true,
        svg: GiveUp,
        // team: 'any',
        players: [
            {
                id: 'rider',
                from: 'any'
            }
        ]
      }
    ],
    legacyEventMap: {
      1: 'end',
      2: 'start',
    }
  }

  export default cyclocross
